export const routesMap = {
  HOME_PAGE: '/',
  BEST_EXECUTION_HOME: '/best-execution',
  CONDUCT_RISK_HOME: '/conduct-risk',
  CONDUCT_RISK_REPORT_PAGE: '/conduct-risk/report',
  CONDUCT_RISK_REPORT_DETAIL: (name: string) => `/conduct-risk/report/${name}/visualizza-report`,
  CONDUCT_RISK_DRIVER_DETAIL: (name: string, driverSlug: string) => `/conduct-risk/report/${name}/visualizza-report/${driverSlug}`,
  REPORT_PAGE: '/best-execution/report',
  VISUALIZZA_REPORT: (name: string) => `/best-execution/report/${name}/visualizza-report`,
  VISUALIZZA_DRIVER: (name: string | number, driverRoute: string) => `/best-execution/report/${name}/visualizza-report/${driverRoute}`,
  VISUALIZZA_INTERMEDIARIO: (name: string | number, driverRoute: string, intermediarioName: string | number) => `/best-execution/report/${name}/visualizza-report/${driverRoute}/${intermediarioName}`,
  RANKING_REPORT: (name: string) => `/best-execution/report/${name}/visualizza-report/ranking`,
  BANKS_PAGE: '/best-execution/banks',
  VISUALIZZA_BANCA: (name: string) => `/best-execution/banks/${name}/visualizza-banca`,
  ALTRE_FONTI: '/best-execution/altre-fonti',
};
